export default "__VITE_ASSET__Cr7y57gZ__"